/**
 * @generated SignedSource<<b00f1ca94b56684e8d5c1e0b08a15d0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HubspotUserConnectionInput = {
  clientMutationId?: string | null;
  connected: boolean;
};
export type HubspotIntegrationUserConnectionMutation$variables = {
  input: HubspotUserConnectionInput;
};
export type HubspotIntegrationUserConnectionMutation$data = {
  readonly connectUserHubspot: {
    readonly hubspotAccount: {
      readonly connectedUsersCount: number;
      readonly userConnected: boolean;
    } | null;
    readonly ok: boolean;
  } | null;
};
export type HubspotIntegrationUserConnectionMutation = {
  response: HubspotIntegrationUserConnectionMutation$data;
  variables: HubspotIntegrationUserConnectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userConnected",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connectedUsersCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HubspotIntegrationUserConnectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "HubspotUserConnectionPayload",
        "kind": "LinkedField",
        "name": "connectUserHubspot",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HubspotAccountNode",
            "kind": "LinkedField",
            "name": "hubspotAccount",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HubspotIntegrationUserConnectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "HubspotUserConnectionPayload",
        "kind": "LinkedField",
        "name": "connectUserHubspot",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HubspotAccountNode",
            "kind": "LinkedField",
            "name": "hubspotAccount",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c01621fc7ace5f39c902b9d6502eeb5",
    "id": null,
    "metadata": {},
    "name": "HubspotIntegrationUserConnectionMutation",
    "operationKind": "mutation",
    "text": "mutation HubspotIntegrationUserConnectionMutation(\n  $input: HubspotUserConnectionInput!\n) {\n  connectUserHubspot(input: $input) {\n    ok\n    hubspotAccount {\n      userConnected\n      connectedUsersCount\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "30708a16a09300cc8f7b182fcc52bc8b";

export default node;
